(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/invite/invite.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/invite/invite.js');
'use strict';

const inviteHandler = svs.arena.pages.invite.handleInvite;
const checkAndShowSyndicateTermsDialogAsync = svs.syndicate.rules_and_terms.checkAndShowSyndicateTermsDialogAsync;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useParams = _ReactRouterDOM.useParams;
const Invite = () => {
  const history = useHistory();
  const params = useParams();
  React.useEffect(() => {
    const checkEligibility = async () => {
      if (svs.core.userSession.isBlocked()) {
        svs.accountservices.national_suspension_message.showNationalSuspensionAcceptInviteSyndicateMessage(() => {
          svs.utils.url.navigate(svs.core.urlMapping.get('startPage'));
        });
      } else if (svs.day_time_limit.data.dayTimeLimit.dayTimeExpired) {
        svs.accountservices.day_time_limit.notices.acceptInviteSyndicate(() => {
          svs.utils.url.navigate(svs.core.urlMapping.get('startPage'));
        });
      } else {
        await checkAndShowSyndicateTermsDialogAsync();
        inviteHandler(params, history);
      }
    };
    checkEligibility();
  }, []);
  return null;
};
svs.arena.pages.invite.Invite = Invite;

 })(window);